import { Veraeusserungsform } from "../../../types/api.types";

export const MARKETING_TYPE_LABELS: Record<Veraeusserungsform, string> = {
  [Veraeusserungsform.subsidized_direct_marketing]:
    "Geförderte Direktvermarktung",
  [Veraeusserungsform.other_direct_marketing]: "Sonstige Direktvermarktung",
  [Veraeusserungsform.feste_einspeiseverguetung]: "Feste Einspeisevergütung"
};

export const MARKETING_TYPE_OPTIONS = Object.entries(MARKETING_TYPE_LABELS).map(
  ([value, label]) => ({ value, label })
);

export function getVeraeusserungsformLabel(veraeusserungsform: string): string {
  return (
    MARKETING_TYPE_LABELS[veraeusserungsform as Veraeusserungsform] ??
    veraeusserungsform
  );
}
